<template>
  <div class="banner">
    <div class="banner-img" :style="{ backgroundImage: `url(${resolvedImg})` }"></div>
    <div class="banner-title">
      <p>{{ title }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: {
    title: {
      type: String,
      default: ""
    },
    img: {
      type: String,
      default: "../assets/img/bgtop.jpg"
    }
  },
  computed: {
    resolvedImg() {
      return this.img && this.img !== "../assets/img/bgtop.jpg"
        ? this.img
        : require("../assets/img/bgtop.jpg");
    }
  }
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 160px;
  position: relative;
  overflow: hidden;
  background-color: #0b2238;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 1;
    background:
      linear-gradient(90deg, rgba(8, 30, 50, 0.78), rgba(8, 30, 50, 0.32) 46%, rgba(8, 30, 50, 0.72)),
      linear-gradient(180deg, rgba(5, 17, 31, 0.12), rgba(5, 17, 31, 0.52));
  }

  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(44, 172, 226, 0.8), transparent);
    box-shadow: 0 0 18px rgba(44, 172, 226, 0.38);
  }

  &-img {
    position: absolute;
    inset: 0;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    transform: scale(1.02);
  }

  &-title {
    width: min(1180px, 92%);
    height: 100%;
    margin: 0 auto;
    position: absolute;
    inset: 0;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    text-align: center;

    p {
      position: relative;
      padding-bottom: 46px;
      font-size: 42px;
      line-height: 1.2;
      font-weight: 600;
      letter-spacing: 0;
      text-shadow: 0 10px 30px rgba(0, 0, 0, 0.28);
    }

    p::after {
      content: "";
      position: absolute;
      left: 50%;
      bottom: 0;
      width: 52px;
      height: 3px;
      border-radius: 999px;
      transform: translateX(-50%);
      background: linear-gradient(90deg, #156da8, #2cace2);
      box-shadow: 0 0 16px rgba(44, 172, 226, 0.58);
    }
  }
}

@media (max-width: 760px) {
  .banner {
    height: 110px;

    &-title p {
      font-size: 34px;
    }
  }
}
</style>
